
import React, {Component} from 'react';
import KeyboardComponent from "./KeyboardComponent";

class TextKeyboardComponent extends Component
{
    render()
    {
        return <div style={{marginLeft:'1vw', width:'98vw'}}>
                    <KeyboardComponent onScreenKeyboardContext={this.props.onScreenKeyboardContext}
                                isShiftOn = {false}
                                isCapsOn={true}
                                standardLayout={[
                                                        "q w e r t y u i o p {bksp} {hide}",
                                                        "a s d f g h j k l",
                                                        "{lock} z x c v b n m",
                                                        "{shift} {space} {ok}"
                                                    ]}
                                shiftLayout={[
                                                    "1 2 3 4 5 6 7 8 9 0 {bksp} {hide}",
                                                    "~ ! @ # £ $ % ^ & * ( )",
                                                    "{standard} + : ; . , ? < > \" '",
                                                ]}
                                capOnLayput={[
                                                    "Q W E R T Y U I O P {bksp} {hide}",
                                                    "A S D F G H J K L",
                                                    "{lock} Z X C V B N M",
                                                    "{shift} {space} {ok}"
                                                ]}/>
                </div>
    }
}

export default TextKeyboardComponent;